import React from 'react';
import "./Home.css";
import Product from './Product';

function Home() {
    return (
        <div className="home">
            <div className="home__container">
                <img className="home__image" src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg" alt="" />

                <div className="home__row">
                    <Product
                        id="12321341" 
                        title="The Lean Startup: How Constant Innovation Creates Radical Successfully Businesses Paperback"
                        price={29.99}
                        image="https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcRIdIJ_GUEKU6N0gd4kaqESl_7-ZiYZhUQ3BFz_dsp9xTnvg52B_6DLcNdTDI4Znu3KweunAKH8dNtywArku3ggPvBXepZRWvqT-TG8WdPRUYjHJoGcRxp7CQ&usqp=CAc"
                        rating={5}

                    />
                    <Product 
                        id="49538094"
                        title="Kenwood kMix stand mixer for baking, Stylish Kitchen Mixer with K-beater,Dough Hook and whisk, 5 litre Glass Bowl"
                        price={239.0}
                        rating={4}
                        image="https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcTJB9hbeDRZmcAVhav54MyLy9TVKjwrhnUH689eeMj_x_5ciL8VMJnToo5HsvihEwvkIgG3PG1EEZ0&usqp=CAc"
                    />
                </div>

                <div className="home__row">
                    <Product 
                        id="4903850"
                        title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
                        price={199.99}
                        rating={3}
                        image="https://m.media-amazon.com/images/I/71gbNOxAVoL._AC_SS130_.jpg"
                    />
                    <Product 
                        id="23445930"
                        title="Amazon Echo (3rd gen) Smart speaker with Alexa, Charcoal fabric"
                        price={98.99}
                        rating={5}
                        image="https://media.croma.com/image/upload/f_auto,q_auto,d_Croma%20Assets:no-product-image.jpg,h_350,w_350/v1605170812/Croma%20Assets/Entertainment/Speakers%20and%20Media%20Players/Images/8944868786206.png"
                    />
                    <Product 
                        id="3254354345"
                        title="New Apple iPad pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th gen)"
                        price={598.99}
                        rating={4}
                        image="https://m.media-amazon.com/images/I/81+N4PFF7jS._AC_UY327_FMwebp_QL65_.jpg"
                    />
                </div>

                <div className="home__row">
                    <Product 
                        id="90829332"
                        title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440"
                        price={1094.98}
                        rating={4}
                        image="https://m.media-amazon.com/images/I/71fEd9glTIL._AC_UY327_FMwebp_QL65_.jpg"
                    />
                </div>

            </div>
        </div>
    )
}

export default Home
